import Bus from "@/lib/Bus";

import { IFolder } from "../../../../server/src/ai/interface/IFolder";
import { IUser } from "server/src/user/IUser";

import { IParamSet } from "./IParam";
import { IBot } from "server/src/ai/interface/IBot";

const bus: Bus = new Bus().getBus();


export class BotStore {
  private static instances: { [parent_id: string]: BotStore } = {};
  botsMap: { [id: string]: IBot } ={}
  private parent_id:string|undefined
 
  selectedFolder:IFolder | undefined;



  private constructor(parent_id:string|undefined) { this.parent_id=parent_id }

  static async getInstance(parent_id:string): Promise<BotStore> {
    if (!BotStore.instances[parent_id]) {
      console.log("****************** creating BOT STORE")
      BotStore.instances[parent_id] = new BotStore(parent_id);
      BotStore.instances[parent_id].initBots(parent_id) 
      BotStore.instances[parent_id].parent_id = parent_id
    }
    return BotStore.instances[parent_id];
  }

  
  async getFoldersForParentId(parent_id: string | undefined, user:IUser): Promise<IFolder[]> {
    let menus = await bus.api("/api/ai/folder/getChildren", {obj: { parent_id: parent_id, user:user}});
    if (!menus) menus=[]
    return menus
  }
  
  async saveBot(bot:IBot) {
    const bot_with_id: IBot | undefined = await bus.api("/api/ai/bot/save", { obj: bot });
    return bot_with_id
  }


  async set_result(bot:IBot, set: IParamSet) {
    if (!bot.id) return;

    set.param.id = bot.id
    const target_ps:IParamSet = { src: undefined, param: set.param}
    const key=set.param.key
    console.log("Drag end target_ps=", target_ps)
    const cc=(<any>bot)
    cc['results'][key] = target_ps
    await this.saveBot(bot)
  }


  async createBot(bot: IBot): Promise<string|undefined> {
    if (!bot) return undefined;
    const ret: IBot | undefined = await bus.api("/api/ai/bot/save", { obj: bot });
    if (ret && ret.id) { 
      this.botsMap[ret.id] = ret
      return ret.id
    }
    return undefined;
  }

 

  async initBots(parent_id: string | undefined, user?:IUser) {
    let list = await bus.api("/api/ai/folder/getBots", {obj: { parent_id: parent_id, user:user}});
    if (!list) list=[]
    this.botsMap = {}
    for (const c of list) {
      this.botsMap[c.id] = c
    }
  }

}





